import React from 'react';
import GradientCircularProgress from './GradientCircularProgress';
import { getPageLoaderStyles } from './pageLoader.styles';
import { Typography } from '@mui/material';

interface PageLoaderProps {
  statusText?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ statusText }) => {
  const styles = getPageLoaderStyles();
  return (
    <div style={styles.overlay}>
      <div style={styles.loader}>
        <GradientCircularProgress />
        {statusText && <Typography style={styles.statusText}>{statusText}</Typography>}
      </div>
    </div>
  );
};

export default PageLoader;
